export default __webpack_public_path__ + "static/media/customer-care-vetting.486f4fc1.jpg";